module.exports = __webpack_public_path__ + "static/media/expert-insights.0d8562d6.png";